import React from 'react'
import ClaimCustomizeIframe from './ClaimCustomizeIframe'

class SubmitClaimSuccess extends React.Component {
  constructor() {
    super()

    this.state = {
      debuggerMode: false
    }
  }

  buildJSON(payload) {
    if (JSON.stringify(payload) === JSON.stringify({})) {
      return null
    } else {
      return JSON.stringify(payload, undefined, 2)
    }
  }

  expectedFromUnumList (date) {
    const parsedDate = Date.parse(date)
    const final_date = moment(parsedDate).add(15, 'day').format('dddd, MMMM DD, YYYY')
    return(
      <ul>
        <li>Over the next few days, you will receive additional documentation from Unum regarding your request.</li>
        <li>If you are eligible for Family Medical Leave, you may be required to submit additional medical documentation
        and/or certification in order to support your leave request.</li>
        {
          gon.employee_layout == 'unum_theme' ?
          <li>
            Unum will notify you via email when your eligibility information and next steps are available.
          </li>
          :
          <li>
            You will be mailed a packet containing your eligibility information and any certification and/or documentation
            that may be needed to support your leave request.
          </li>
        }
        <li>If documentation is required, it will be due back to Unum 15 days from today or as specified by Unum.</li>
      </ul>
    )
  }

  renderDebuggerMode() {
    return (
      <div>
        <div className='payload-response'>
          <div className='response-title'>
            Request
          </div>
          <pre className='response-detail'>
            { this.buildJSON(this.props.request) }
          </pre>
        </div>
        <div className='payload-response'>
          <div className='response-title'>
            Response
          </div>
          <pre className='response-detail'>
            { this.buildJSON(this.props.response) }
          </pre>
        </div>
      </div>
    )
  }

  renderNormalMode() {
    const { customizable_screen_content, workflow_unum } = this.props
    const { claim_success } = customizable_screen_content

    if (claim_success) {
      return this.renderCustomContentDiv(claim_success)
    }

    const faCheckDivStyle = {
      height: 84,
      minWidth: 96,
      display: 'flex',
      justifyContent: 'center',
      border: '10px solid #8BC758',
      alignItems: 'center',
      borderRadius: 10
    }
    const faCheckStyle = {
      fontSize: 48,
      color: '#8BC758'
    }
    if (workflow_unum) {
      return this.renderUnumSuccessDiv(faCheckDivStyle, faCheckStyle)
    } else {
      return this.renderLeaveLogicSucessDiv(faCheckDivStyle, faCheckStyle)
    }
  }

  renderCustomContentDiv(claim_success) {
    return (
      <div className="submit-claim-div col-lg-10">
        <div className='submit-claim-success-text'>
          Thank you
          <br />
          Your request has been submitted
        </div>
        <ClaimCustomizeIframe content={claim_success} />
        <div className='back-to-claim-btn'>
          { this.props.redirectButton() }
        </div>
      </div>
    )
  }

  renderUnumSuccessDiv(faCheckDivStyle, faCheckStyle) {
    return (
      <div className="submit-claim-div col-lg-10">
        <div className='submit-claim-success-text'>
          Your Request has been successfully sent to Unum
        </div>
        <div className='claim-requested-body'>
          <div className='claim-requested-leave'>
            <div style= { faCheckDivStyle }>
              <i className='fa fa-arrow-up' style={ faCheckStyle }></i>
            </div>
            <div className='submit-claim-circle-check'>
              <p>We are submitting your
              Request for your {this.props.leave_scenario} to
              Unum.</p>
              <p><strong>
                Your request is being processed. Please check back
                shortly for your request identification information.
              </strong></p>
              <p><strong>
                Now that your request has been submitted, changes to your LeavePlan will no longer update Unum. To make future updates to your request or claim with Unum, visit Unum's claim portal.
              </strong></p>
              <p>If you have any questions, please reach out to us
              through in-App chat.</p>
            </div>
          </div>
          <div className='claim-happens-text'>
            <strong> What happens now? </strong><br/>
            {
              this.props.unumTheme() ?
              <span>
                <p>Your request is now being reviewed by Unum.
                    You can monitor the status of your request by going to
                  <a href='/app/claims' target='_blank'> Unum's claim portal</a>. Please allow up to 24 hours for status updates upon submission.</p>
              </span>
              :
              <span>
                <p>Your request is now being reviewed by Unum.
                    You can monitor the status of your request by going to
                    <a href='https://services.unum.com' target='_blank'> Unum's claim portal </a>
                    or by downloading the app for Android or iOS. Please allow up to 24 hours for status updates upon submission.</p>
                    <div className='claim-customer-apps col-md-10 col-lg-8'>
                      <a href='https://play.google.com/store/apps/details?id=com.unum.mobile&hl=en_US' target='_blank'>
                        <div className='claim-app-link'>
                          <img src="https://lh3.googleusercontent.com/PIq0mSy6mqGZZ95ybDEdEa3I8G_lkj5G9l7UJRTzUI_3rrM6kxyqhJNe4VLRsJQGNMM=s180-rw" alt="sometext" height='70px' width='70px' />
                          <p>Android</p>
                        </div>
                      </a>
                      <h5> or </h5>
                      <a href='https://itunes.apple.com/us/app/unum-customer/id926425669?mt=8' target='_blank'>
                        <div className='claim-app-link'>
                          <img src="https://lh3.googleusercontent.com/PIq0mSy6mqGZZ95ybDEdEa3I8G_lkj5G9l7UJRTzUI_3rrM6kxyqhJNe4VLRsJQGNMM=s180-rw" alt="sometext" height='70px' width='70px' />
                          <p>iOS</p>
                        </div>
                      </a>
                    </div>
              </span>
            }
          </div>
        </div>
        <div className='expected-from-unum-div'>
          <div className='expected-from-unum-container'>
            <div className='expected-from-unum-header'>
              What can you expect from Unum?
            </div>
            <hr />
            <div className='expected-from-unum-text'>
              { this.expectedFromUnumList(this.props.reported_at) }
            </div>
          </div>
        </div>
        <div className='back-to-claim-btn'>
          { this.props.redirectButton() }
        </div>
      </div>
    )
  }

  renderLeaveLogicSucessDiv(faCheckDivStyle, faCheckStyle) {
    return (
      <div className="submit-claim-div col-lg-10">
        <div className='submit-claim-success-text'>
          Thank you
          <br />
          Your request has been submitted
        </div>
        <div className='claim-requested-body'>
          <div className='claim-requested-leave'>
            <div style= { faCheckDivStyle }>
              <i className='fa fa-arrow-up' style={ faCheckStyle }></i>
            </div>
            <div className='submit-claim-circle-check'>
              <p>We have submitted your
              Leave of Absence Request
              for your {this.props.leave_scenario} to {this.props.request_recipient}.</p>
            </div>
          </div>
          <div className='claim-happens-text'>
            <strong> What happens now? </strong><br/>
            <p>It may take up to 1 business day for {this.props.request_recipient} to receive the request. In the meantime check your LeaveLogic LeavePlan tasks for additional information on what you can expect.</p>
          </div>
        </div>
        <div className='back-to-claim-btn'>
        { this.props.redirectButton() }
        </div>
      </div>
    )
  }

  renderDebuggerModeSwitch() {
    let switchText = 'Switch to Debugger Mode'
    if (this.state.debuggerMode) {
      switchText = 'Switch to Normal Mode'
    }
    return this.props.is_admin ? (
      <span
        className='submit-view-switch'
        onClick={(e) => this.setState({debuggerMode: !this.state.debuggerMode})}
      >
        { switchText }
      </span>
    ) : null
  }

  renderSection() {
    if (this.state.debuggerMode) {
      return this.renderDebuggerMode()
    } else {
      return this.renderNormalMode()
    }
  }

  render () {
    return (
      <div className='claim-container'>
        <div className='submit-view-buttons'>
          <a
            className='submit-view-switch'
            href={`/claims/${this.props.id}/edit`}
          >
            Edit
          </a>
          { this.renderDebuggerModeSwitch() }
        </div>
        { this.renderSection() }
      </div>
    )
  }
}

export default SubmitClaimSuccess;
